export enum BargainType {
    Sale = "For sale",
    Rent = "For rent"
}